<template lang="pug">
  .page-content
    el-row(:gutter="40")
      el-col(:lg="8" :md="8" :sm="24")
        h1.title Informações
        .menu
          .item-menu(v-if="EXIBIR_OBSERVACOES")
            el-button(
              type="text",
              index='observacoesImportantes',
              @click="changeRoute('observacoesImportantes', 'Observações importantes')"
              :class="{'color-menu ': getSelectedMenu === 'observacoesImportantes'}"
            ) Observações importantes

          .item-menu(v-if="EXIBIR_DUVIDAS_FREQUENTES")
            el-button(
              type="text",
              index='duvidasFrequentes',
              @click="changeRoute('duvidasFrequentes', 'Dúvidas frequentes')"
              :class="{'color-menu ': getSelectedMenu === 'duvidasFrequentes'}"
            ) Dúvidas Frequentes

          .item-menu
            el-button(
              v-if="!isIcmBio"
              type="text",
              index='documentosCadastro',
              @click="changeRoute('documentosCadastro', 'Documentos necessários (cadastro)')"
              :class="{'color-menu ': getSelectedMenu === 'documentosCadastro'}"
            ) Documentos necessários (cadastros)
          .item-menu(v-if="EXIBIR_CREDENCIADOS")
            el-button(
              type="text",
              index='credenciadosListagem',
              @click="changeRoute('credenciadosListagem', 'Credenciados')"
              :class="{'color-menu ': getSelectedMenu === 'credenciadosListagem'}"
            ) Credenciados

          .item-menu(v-if="EXIBIR_MODELOS_DOCS")
            el-button(
              type="text",
              index='modelosDocumentos',
              @click="changeRoute('modelosDocumentos', 'Modelos de documentos')"
              :class="{'color-menu ': getSelectedMenu === 'modelosDocumentos'}"
            ) Modelos de documentos
      el-col(:lg="16" :md="16")
        .main(v-if="dadosCarregados")
          router-view
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  async mounted () {
    await this.carregarDados()
    if (this.$route.name === 'informacao' && this.EXIBIR_OBSERVACOES) {
      this.$router.push({
        name: 'observacoesImportantes'
      })
    } else if (this.$route.name === 'informacao') {
      this.$router.push({
        name: 'duvidasFrequentes'
      })
    }
  },

  data () {
    return {
      dadosCarregados: false,
      tituloPagina: this.$route.meta.title
    }
  },

  computed: {
    ...mapState({
      EXIBIR_OBSERVACOES: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_OBSERVACOES,
      EXIBIR_MODELOS_DOCS: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_MODELOS_DOCS,
      EXIBIR_CREDENCIADOS: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_CREDENCIADOS,
      EXIBIR_DUVIDAS_FREQUENTES: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_DUVIDAS_FREQUENTES
    }),

    getSelectedMenu () {
      return this.$route.meta.menu
    },

    getRoute () {
      return this.$route.name
    },
    isNotBahia () {
      return !process.env.ESTADO === 'ba'
    },
    isIcmBio () {
      return process.env.ESTADO === 'default'
    }
  },

  methods: {
    ...mapActions({
      getPerguntas: 'perguntaFrequente/byNumero'
    }),
    carregarDados () {
      this.getPerguntas().then(() => {
        this.dadosCarregados = true
      })
    },
    changeRoute (rota, titulo) {
      this.tituloPagina = titulo
      this.$router.push({
        name: rota
      })
    }
  },
  watch: {
    getRoute () {
      if (this.$route.name[0] === 'informacao') {
        this.$router.push({
          name: 'observacoesImportantes'
        })
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '@/assets/styles/_variables.scss';

  .main {
    color: $font-color;
    text-align: left;
    margin-top: 20px;
  }

  .menu {
    text-align: left;
  }

  .item-menu {
    cursor: pointer;
  }

  .item-menu:hover {
    background-color: #FFF;
    color: $color-primary;
  }

  .item-menu:focus a {
    background-color: #FFF;
    color: $color-primary;
  }

  .item-menu:active a {
    background-color: #FFF;
    color: $color-primary;
  }

  .title {
    color: $color-primary;
  }

  .el-button--text {
    color: $font-color;
    font-size: $font-size-text;
  }
  .color-menu {
    color: $color-primary;
  }

</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/Informacao.vue